import { render, staticRenderFns } from "./title-comp1.vue?vue&type=template&id=5d41bfac&scoped=true"
import script from "./title-comp1.vue?vue&type=script&lang=js"
export * from "./title-comp1.vue?vue&type=script&lang=js"
import style0 from "./title-comp1.vue?vue&type=style&index=0&id=5d41bfac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d41bfac",
  null
  
)

export default component.exports